class DisplayOnlyFieldController {

    $onInit() {
        this.filterLookupList();
    }

    filterLookupList() {
        if (this.lookupList) {
            this.lookupList = this.lookupList.filter((item) => {
                if (item.id === this.value) {
                    return true;
                }
                if (Array.isArray(this.value)) {
                    return this.value.includes(item.id);
                }
            })
        }
    }

}

export default DisplayOnlyFieldController;


// WEBPACK FOOTER //
// ./app/common/form-fields/display-only-field/display-only-field-controller.js